import { classnames } from 'Utils/classnames/classnames.utils';
import type { ReactNode } from 'react';
import React from 'react';
import { COLORS, COMPLEMENTARY_COLORS } from 'Components/utils/color/colors';
type Props = {
  children: ReactNode;
  className?: string;
  color: Colors;
  controlsId?: string;
  id?: string;
  isActive?: boolean;
  onClick?: () => void;
};
export const NavigationTabsHeader = ({
  children,
  className,
  color = COLORS.LIGHT_SAND,
  controlsId,
  id,
  isActive,
  onClick,
}: Props) => (
  <button
    aria-controls={controlsId}
    aria-selected={isActive}
    className={classnames(
      'cursor-pointer text-14 transition-colors duration-250 ease-in',
      `hocus:bg-${color} h-50 min-w-120 p-5 lg:h-60 hocus:text-${COMPLEMENTARY_COLORS[color]}`,
      {
        [`bg-${color} arrow-down-top arrow-small arrow-white lg:arrow-none font-bold text-${COMPLEMENTARY_COLORS[color]}`]:
          isActive,
        'bg-white text-black': !isActive,
      },
      className,
    )}
    id={id}
    onClick={!isActive ? onClick : () => {}}
    role="tab"
    tabIndex={isActive ? 0 : -1}
    type="button"
  >
    {children}
  </button>
);
